"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
const state_1 = require("@airstudio/state");
const react_redux_1 = require("react-redux");
const WorkspaceItem = ({ name, setIsActive, isActive = false }) => {
    return (react_1.default.createElement(rsuite_1.Button, { onClick: () => setIsActive(), disabled: isActive, appearance: "subtle", size: "lg", block: true, style: { textAlign: 'left' } },
        react_1.default.createElement(rsuite_1.Avatar, { circle: true }, name[0]),
        react_1.default.createElement("span", { style: { marginLeft: 15 } }, name)));
};
exports.WorkspacePicker = ({ isVisible, setIsVisible }) => {
    const workspaces = react_redux_1.useSelector(state_1.Selectors.Workspaces.getAll);
    const selectedWorkspace = react_redux_1.useSelector(state_1.Selectors.Workspaces.getActiveWorkspace);
    const dispatchSwitchWorkspace = state_1.Operations.Workspaces.switchActive(react_redux_1.useDispatch());
    if (workspaces.length === 0 || !selectedWorkspace) {
        return react_1.default.createElement("div", null, "Loading");
    }
    const selectWorkspace = async (workspaceId) => {
        const isSuccessful = await dispatchSwitchWorkspace(workspaceId);
        if (isSuccessful) {
            setIsVisible(false);
        }
    };
    return (react_1.default.createElement(rsuite_1.Modal, { size: "xs", show: isVisible, onHide: () => setIsVisible(false) },
        react_1.default.createElement(rsuite_1.Modal.Header, { closeButton: false },
            react_1.default.createElement(rsuite_1.Modal.Title, { style: { textAlign: 'center' } }, "Switch Workspaces")),
        react_1.default.createElement(rsuite_1.Modal.Body, null, workspaces.map((workspace) => (react_1.default.createElement(WorkspaceItem, { key: workspace.id, setIsActive: () => selectWorkspace(workspace.id), isActive: selectedWorkspace.id === workspace.id, name: workspace.id }))))));
};
//# sourceMappingURL=index.js.map